<script setup>
import { railsApi } from '@/utils/railsApi'

definePage({
  meta: {
    adminArea: true,
  },
})

const { t } = useI18n()

const loading = ref(false)
const error = ref('')
const aggregates = ref([])

const headers = computed(() => [
  { title: t('admin.customExerciseSubmissions.columns.name'), key: 'sample_name' },
  { title: t('admin.customExerciseSubmissions.columns.muscleGroup'), key: 'muscle_group' },
  { title: t('admin.customExerciseSubmissions.columns.modality'), key: 'modality' },
  { title: t('admin.customExerciseSubmissions.columns.submissions'), key: 'submission_count' },
  { title: t('admin.customExerciseSubmissions.columns.trainers'), key: 'trainer_count' },
])

const muscleGroupLabel = value => t(`exerciseCatalog.muscleGroups.${value}`)
const modalityLabel = value => t(`exerciseCatalog.modalities.${value}`)

const load = async () => {
  loading.value = true
  error.value = ''
  try {
    const data = await railsApi('/api/v1/admin/custom_exercise_submissions/aggregate')

    aggregates.value = data.aggregates || []
  }
  catch (err) {
    error.value = err.payload?.error || err.message || t('admin.customExerciseSubmissions.loadError')
  }
  finally {
    loading.value = false
  }
}

onMounted(load)
</script>

<template>
  <div>
    <h1 class="text-h4 mb-2">
      {{ t('admin.customExerciseSubmissions.title') }}
    </h1>
    <p class="text-medium-emphasis mb-4">
      {{ t('admin.customExerciseSubmissions.subtitle') }}
    </p>

    <VAlert
      v-if="error"
      type="error"
      variant="tonal"
      class="mb-4"
      role="alert"
    >
      {{ error }}
    </VAlert>

    <VCard>
      <VCardText>
        <VProgressLinear
          v-if="loading"
          indeterminate
          class="mb-4"
        />

        <p
          v-if="!loading && !aggregates.length"
          class="text-medium-emphasis mb-0"
        >
          {{ t('admin.customExerciseSubmissions.empty') }}
        </p>

        <VDataTable
          v-else-if="aggregates.length"
          :headers="headers"
          :items="aggregates"
          :items-per-page="25"
          item-value="normalized_name"
        >
          <template #item.muscle_group="{ item }">
            {{ muscleGroupLabel(item.muscle_group) }}
          </template>
          <template #item.modality="{ item }">
            {{ modalityLabel(item.modality) }}
          </template>
        </VDataTable>
      </VCardText>
    </VCard>
  </div>
</template>
